import { defineStore } from 'pinia'
import Vue from 'vue'
import router from '@/router/index'
import axios from '@/api/index'
import qs from 'qs'
import Nprogress from 'nprogress';
export const uselayoutStore = defineStore('layoutstore', {
    state: () => {
      return {
        headerDetails: []
      }
    },
    getters: {
        headerDetailsData: (state) => state.headerDetails,
        headerDetailsGetter() {
            return this.headerDetailsData
        },
        socket_raiseTicketNotification() {
            return this.headerDetailsData
        },
        socket_unassignedTaskNotify() {
            return this.headerDetailsData
        },
        socket_unReadMessageNotify() {
            return this.headerDetailsData
        },
        socket_assignedTaskNotify() {
            return this.headerDetailsData
        },
        socket_userPendingNotify() {
            return this.headerDetailsData
        },
        socket_natlogFailures() {
            return this.headerDetailsData
        },
    },
    actions: {
        fetchHeaderDetails() {
            return new Promise((resolve) => {
                axios.get("/dashboard/jaze_header")
                .then(response => {
                    Nprogress.done()
                    localStorage.removeItem('socEnable')
                    localStorage.removeItem('socAdmin')
                    localStorage.setItem('socAdmin', response.data.message.Auth.User.id);
                    var socEnable = response.data.message.nodejsenabled
                    localStorage.setItem('socEnable', socEnable.toString());
                    if (localStorage.getItem("socketConnected") != "yes") {
                        const event = new Event('build');
                        window.dispatchEvent(event);
                    }
                    this.headerDetails = response.data.message
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status == 403) {
                            router.push("/signin");
                        }
                    }
                })
            });
        },
        clearLayoutState() {
            this.headerDetails = [];
        },
    }
  })